import { Box, List, Typography } from "@mui/material";
import {
  AddLocation,
  Autorenew,
  DashboardOutlined,
  ScheduleOutlined,
  SpaceDashboardOutlined
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useSelector } from "../../../app/helpers";
import { RootState } from "../../../app/rootReducer";
import { PricingModel } from "../../../features/Login/typings/login.types";
import { ListItemLink } from "./list-item-link.component";

type P = {
  onToggleDrawerMobile: () => void;
  toggleAdmin: () => void;
};

export const MainDrawerList: React.FC<P> = ({ onToggleDrawerMobile, toggleAdmin }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const isDashboard2Active = pathname === "/dashboard2";

  const {
    userInformation: { pricingModels },
    requireSettings,
    settings
  } = useSelector((state: RootState) => state.login);

  const dashboardPrimary = (
    <Box component="span" sx={{ display: "inline-flex", alignItems: "baseline", gap: 0.75 }}>
      <span>{t("Dashboard")}</span>
      <Typography
        component="span"
        data-testid="dashboard2-new-badge"
        sx={{
          m: "auto 0",
          fontSize: "0.65rem",
          fontWeight: 500,
          textTransform: "none",
          color: isDashboard2Active ? "primary.contrastText" : "primary.main",
          textShadow: theme => {
            if (isDashboard2Active) {
              return "0 1px 1px rgba(0, 0, 0, 0.2)";
            }
            if (theme.palette.mode === "dark") {
              return "0 1px 1px rgba(255, 255, 255, 0.28)";
            }
            return "0 1px 1px rgba(0, 0, 0, 0.24)";
          }
        }}
      >
        {t("New")}
      </Typography>
    </Box>
  );

  return (
    <List
      data-testid="main-drawer-list-parent"
      onClick={() => {
        onToggleDrawerMobile();
        toggleAdmin();
      }}
      sx={{ paddingBottom: 0 }}
    >
      <ListItemLink
        id="home"
        to={"/"}
        primary={t("Home")}
        data-testid="home"
        icon={<DashboardOutlined />}
      />
      <ListItemLink
        id="dashboard2"
        to={"/dashboard2"}
        primary={dashboardPrimary}
        data-testid="dashboard2"
        icon={<SpaceDashboardOutlined />}
      />
      <ListItemLink
        disabled={requireSettings}
        id="booking"
        to={"/booking/0"}
        data-testid="booking"
        primary={t("Booking")}
        icon={settings.useAutomatedBooking ? <Autorenew /> : <AddLocation />}
      />
      {/* not used currently */}
      {pricingModels.includes(PricingModel.ENTERPRISE) && (
        <ListItemLink
          id="schedule"
          to={"/schedule"}
          data-testid="schedule"
          primary={t("Schedule")}
          icon={<ScheduleOutlined />}
        />
      )}
    </List>
  );
};
